import { Route } from '@angular/router';
import { canActivate } from './shared';

export const appRoutes: Array<Route> = [
  {
    path: 'auth',
    loadChildren: async () => import('./auth').then((m: { authRoutes: Array<Route> }) => m.authRoutes)
  },
  {
    path: 'process/documents/:processId',
    loadComponent: async () =>
      import('./public/views/public-document-upload/public-document-upload.component')
        .then(m => m.PublicDocumentUploadComponent)
  },
  {
    path: 'public/agreement/:processId',
    loadComponent: async () =>
      import('./public/views/agreement-preview/agreement-preview.component')
        .then(m => m.AgreementPreviewComponent)
  },
  {
    path: 'public/agreement/:processId/sign',
    loadComponent: async () =>
      import('./public/views/signature-capture/signature-capture.component')
        .then(m => m.SignatureCaptureComponent)
  },
  {
    path: 'public/fica-upload/:processId',
    loadComponent: async () =>
      import('./public/views/fica-upload/fica-upload.component')
        .then(m => m.FicaUploadComponent)
  },
  {
    path: 'public/document-requests/:processId',
    loadComponent: async () =>
      import('./public/views/document-request-upload/document-request-upload.component')
        .then(m => m.DocumentRequestUploadComponent)
  },
  {
    // FLO-1516 — Innoble client bank statement upload (no login).
    path: 'public/innoble/cycles/:processId',
    loadComponent: async () =>
      import('./public/views/innoble-cycle-upload/innoble-cycle-upload.component')
        .then(m => m.InnobleCycleUploadComponent)
  },
  {
    // FLO-1661 — Vetting Labs provider application page (no login), shown in a phone frame for demos.
    path: 'public/vettinglabs/apply',
    loadComponent: async () =>
      import('./public/views/vettinglabs-apply/vettinglabs-apply.component')
        .then(m => m.VettingLabsApplyComponent)
  },
  {
    // The same page as the plain link an applicant opens: no phone frame, responsive to the device.
    path: 'public/vettinglabs/apply/link',
    data: { raw: true },
    loadComponent: async () =>
      import('./public/views/vettinglabs-apply/vettinglabs-apply.component')
        .then(m => m.VettingLabsApplyComponent)
  },
  {
    path: 'public/vettinglabs/corrections/:processId',
    loadComponent: async () =>
      import('./public/views/vettinglabs-correction-upload/vettinglabs-correction-upload.component')
        .then(m => m.VettingLabsCorrectionUploadComponent)
  },
  {
    path: 'public/vettinglabs/renewals/:processId',
    loadComponent: async () =>
      import('./public/views/vettinglabs-renewal-upload/vettinglabs-renewal-upload.component')
        .then(m => m.VettingLabsRenewalUploadComponent)
  },
  {
    path: 'public/vettinglabs/referees/:processId/:refereeId',
    loadComponent: async () =>
      import('./public/views/vettinglabs-referee-response/vettinglabs-referee-response.component')
        .then(m => m.VettingLabsRefereeResponseComponent)
  },
  {
    path: 'apply',
    loadChildren: async () => import('./public/public.routes').then(m => m.publicRoutes)
  },
  {
    path: '',
    canActivate: [canActivate],
    loadChildren: async () => import('./dashboard').then((m: { dashboardRoutes: Array<Route> }) => m.dashboardRoutes)
  }
];
